<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="sale && sale.id">{{ 'SALES.SALES_FORM.EDIT' | translate }}</span>
    <span *ngIf="!sale || !sale.id">{{ 'SALES.SALES_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="sale-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="modal-section-title" *ngIf="form.get('enquiry_id').value">
      {{ 'SALES.SALES_FORM.ENQUIRY' | translate }}:
      <span
        class="btn btn-link enquiry-btn"
        *ngIf="form.get('enquiry_id').value"
        (click)="editEnquiry(form.get('enquiry_id').value)"
      >
        #{{ form.get('enquiry_id').value }}
      </span>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <app-company-select [parentFormGroup]="form" [isDefaultSO]="isAddNewSale"></app-company-select>
      </div>

      <div class="col-sm-4">
        <app-client-select [parentFormGroup]="form"></app-client-select>
      </div>

      <div class="col-sm-4">
        <app-event-select [parentFormGroup]="form"></app-event-select>
      </div>

      <div class="col-sm-4">
        <app-user-select
          [parentFormGroup]="form"
          [passFormControlName]="'sales_agent_id'"
          [label]="'SALES.SALES_FORM.SALES_AGENT_AND_SALES_MANAGER' | translate"
          [roleType]="[UserRoleType.SALES_AGENT, UserRoleType.SALES_MANAGER]"
        ></app-user-select>
      </div>

      <div class="col-sm-4">
        <app-user-select
          [parentFormGroup]="form"
          [passFormControlName]="'reservation_agent_id'"
          [label]="'SALES.SALES_FORM.RESERVATION_AGENT_AND_RESERVATION_MANAGER' | translate"
          [roleType]="[UserRoleType.RESERVATION_AGENT, UserRoleType.RESERVATION_MANAGER]"
        ></app-user-select>
      </div>

      <div class="col-sm-4">
        <app-user-select
          [parentFormGroup]="form"
          [passFormControlName]="'customer_care_agent_id'"
          [label]="'SALES.SALES_FORM.CUSTOMER_CARE_AGENT' | translate"
          [roleType]="UserRoleType.CUSTOMER_CARE_AGENT"
        ></app-user-select>
      </div>

      <div class="col-sm-4">
        <label>{{ 'SALES.SALES_FORM.CAMPAIGN' | translate }}</label>
        <app-type-select
          [groupType]="'sale_campaign'"
          [passFormControlName]="'campaign_id'"
          [parentFormGroup]="form"
        ></app-type-select>
      </div>

      <div class="col-sm-4">
        <label>{{ 'SALES.SALES_FORM.SOURCE' | translate }}</label>
        <app-type-select
          [groupType]="'sale_source'"
          [passFormControlName]="'source_id'"
          [parentFormGroup]="form"
        ></app-type-select>
      </div>

      <div class="col-sm-4">
        <label>{{ 'SALES.SALES_FORM.CHANNEL' | translate }}</label>
        <app-type-select
          [groupType]="'sale_channel'"
          [passFormControlName]="'channel_id'"
          [parentFormGroup]="form"
        ></app-type-select>
      </div>

      <div class="col-sm-3">
        <label>{{ 'SALES.SALES_FORM.STATUS' | translate }}</label>
        <app-type-select
          [groupType]="'sale_status'"
          [passFormControlName]="'status_id'"
          [parentFormGroup]="form"
        ></app-type-select>
      </div>

      <div class="col-sm-9">
        <label>{{ 'SALES.SALES_FORM.STATUS_REASON' | translate }}</label>
        <input type="text" class="form-control" formControlName="status_reason" />
      </div>

      <div class="col-sm-3">
        <label>{{ 'SALES.SALES_FORM.ASSIGN_TO' | translate }}</label>
        <app-user-and-group-select [parentFormGroup]="form" [selectableGroup]="false"></app-user-and-group-select>
      </div>

      <div class="col-sm-2">
        <label>{{ 'SALES.SALES_FORM.ASSIGN_DATE' | translate }}</label>
        <app-date-picker
          [FormControl]="form.get('assign_date')"
          [minDate]="dateNow"
          [required]="false"
        ></app-date-picker>
      </div>

      <div class="col-sm-7">
        <app-tags-select [parentFormGroup]="form" [model]="LaravelModelsEnum.SALE"></app-tags-select>
      </div>

      <div class="col-sm-12">
        <label>{{ 'SALES.SALES_FORM.NOTE' | translate }}</label>
        <textarea class="form-control" formControlName="note" pInputTextarea autoResize="true"></textarea>
      </div>

      <div class="col-sm-4">
        <div class="custom-control custom-checkbox checkbox-margin">
          <input
            type="checkbox"
            class="custom-control-input"
            formControlName="from_advertising"
            id="from-advertising"
          />
          <label class="custom-control-label" for="from-advertising">{{
            'SALES.SALES_FORM.FROM_ADVERTISING' | translate
          }}</label>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="custom-control custom-checkbox checkbox-margin">
          <input
            type="checkbox"
            class="custom-control-input"
            formControlName="mail_unactive"
            id="mail_unactive2"
          />
          <label class="custom-control-label" for="mail_unactive2">{{
            'SALES.SALES_FORM.MAIL_UNACTIVE' | translate
          }}</label>
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="sale-form" [disabled]="form.invalid">
    {{ 'SALES.SALES_FORM.SAVE' | translate }}
  </button>
</div>
